class AccountActivation extends HTMLElement {
  constructor() {
    super();
    document.addEventListener('DOMContentLoaded', () => {
      const body = document.body;
      const triggerModal = document.querySelector('.js-trigger-activation');
      const activationModal = this;
      const modalCancel = this.querySelector('[data-account-activation="cancel"]');
      const modalClose = this.querySelector('[data-account-activation="close"]');
      const modalOverlay = this.querySelector('.modal__overlay');
      const modalCard = this.querySelector('.modal__card');
      const modalForm = this.querySelector('[data-account-activation="form"]');
      const formContainers = this.querySelectorAll('[data-account-activation="toggleHide"');
      const resultContainer = this.querySelector('.js-result');
      const errorField = this.querySelector('[data-account-activation="invalid"]');

      function openModal() {
        activationModal.classList.add('open');
        body.classList.add('locked');
      }
      
      function closeModal() {
        modalForm.reset();
        activationModal.classList.remove('open');
        body.classList.remove('locked');
        errorField.classList.add('is-hidden');

        if(!resultContainer.classList.contains('is-hidden')){
          formContainers.forEach(function (toggleHide) {
            toggleHide.classList.toggle('is-hidden');
          });
        }
      }

      triggerModal.addEventListener('click', function(){
        openModal();
      })

      modalCancel.addEventListener('click', function(){
        closeModal();
      })

      modalClose.addEventListener('click', function(){
        closeModal();
      })

      modalOverlay.addEventListener('click', function(e){
        closeModal();
      })

      modalCard.addEventListener('click', function(e){
        e.stopPropagation();
        return false;
      })

      modalForm.addEventListener('submit', function(event){
        submitHandler(event);
      })

      function validateEmail() {
        let email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }

      function serialize(form) {
        let requestArray = [];
        form.querySelectorAll('[name]').forEach((elem) => {
            requestArray.push(elem.name + '=' + elem.value);
        });
        if(requestArray.length > 0)
            return requestArray.join('&');
        else
            return false;
      } 

      function submitHandler(event) {
        event.preventDefault();
        event.stopPropagation();


        let _this = event.target,
            email = _this.querySelector('#AccountActivationEmail'),
            value = email.value,
            data = serialize(modalForm);

        if (!value) {
          email.focus();
          return;
        }

        if (!validateEmail(value)) {
          errorField.classList.remove('is-hidden');
          email.focus();
          return;
        }

        fetch('https://wotio.app/util_custactivate_invite.php', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: data
        }).then(function (response) {

          if (response.ok) {

            formContainers.forEach(function (toggleHide) {
              toggleHide.classList.toggle('is-hidden');
            });

            return;
          }
          
          throw Error('Customer account activation request failed');
        })
      }
    })
  }
}
customElements.define('account-activation', AccountActivation)